import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import "./ContactUs.css";
import Form from 'react-bootstrap/Form';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";

import EmailIcon from "../../Assets/email.png"

type ContactUsFormInputs = {
  first_name: string;
  last_name: string;
  message: string;
  email: string;
};

const validation = Yup.object().shape({
  first_name: Yup.string().required("Make is required"),
  last_name: Yup.string().required("Model is required"),
  message: Yup.string().required("Year is required"),
  email: Yup.string().required("Email is required")
});

interface Props {
  contactRequest: (first_name: string, last_name: string, message: string, email: string) => void;
}

const ContactUs = ({contactRequest}: Props) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm<ContactUsFormInputs>({ resolver: yupResolver(validation) });
  
    const handleContact = (form: ContactUsFormInputs) => {
      contactRequest(form.first_name, form.last_name, form.message, form.email);
      
    };

  return (
    <section className="contact-us">
      <Container className="shadow rounded bg-white">
        <Row className="justify-content-md-center">
          <div className="container text-center mt-4">
            <h1 className="mb-4">Contact Us</h1>
            <p className="mb-4">Have some questions or want to contribute? Send us a message here</p>
            <form onSubmit={handleSubmit(handleContact)}>
              <div className="row justify-content-center">
              <div className="col-md-5 text-left">
                <img
                  src={ EmailIcon } className="email-image p-0 img-fluid rounded"
                  alt="Email image"
                />
                  <address>
                    Email: <a href="mailto:admin@mtbpartpicker.com">admin@mtbpartpicker.com</a>
                  </address>
              </div>
              <div className="col-md-5 text-left">
              <div className="row justify-content-center">
                <div className="col-md-10 text-left">
                  <label className="form-label d-block text-start">First name</label>
                  <Form.Control id="firstName" type="text" placeholder="John" {...register("first_name")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Last name</Form.Label>
                  <Form.Control id="last_name" type="text" placeholder="Smith" {...register("last_name")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Message</Form.Label>
                  <Form.Control id="message" type="text" placeholder="..." {...register("message")}/>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-10">
                  <Form.Label className="form-label d-block text-start">Email</Form.Label>
                  <Form.Control id="email" type="email" placeholder="email@example.com" {...register("email")}/>
                </div>
              </div>
              <div className="row justify-content-center mt-3">
                <div className="col-md-9">
                  <Button type="submit" className="btn btn-primary w-100 mt-4 mb-4">Submit</Button>
                </div>
              </div>
              </div>
              </div>
            </form>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default ContactUs;
